import icon from "images/icons/icon-edit.svg?raw"
import parse from "html-react-parser"

export default function EditIcon() {
  return (
    <span className="svg-icon">{parse(icon)}</span>
  )
}
